/**
 * Returns whether the provided cell text should be treated as a formula.
 */
export const isFormula = (text: string | null): boolean => !!text && text.toString().startsWith('=');
